import script from "./AccountEditPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountEditPage.vue?vue&type=script&setup=true&lang=js"

import "./AccountEditPage.vue?vue&type=style&index=0&id=541465e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-541465e4"]])

export default __exports__